exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyrightMessage[data-v-7f1ee4d3]{position:fixed;left:0;right:0;bottom:0px;z-index:999;line-height:30px;text-align:center;color:#76838f;background-color:#fff;font-size:14px}\n", ""]);

// exports
